if (typeof ProductCard !== 'function') {

  class ProductCard extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('change', this._onChange.bind(this));
    }

    _onChange(e) {
      const target = e.target;
      if (!target || !target.dataset || !target.dataset.variantId) return;
      const name = (target.name || '').toLowerCase();
      if (!name.includes('color') && !name.includes('colour')) return;
      this._changeContent(target.dataset.variantId);
    }

    _changeContent(variantId) {
      this._loadData().then((data) => {
        const entry = data.find(({ variant_id }) => String(variant_id) === String(variantId));
        if (!entry) return;
        const parsed = new DOMParser().parseFromString(entry.markup, 'text/html');
        const newCard = parsed.querySelector('product-card');
        if (!newCard) return;
        if (this.querySelector('.product-item__quick-buy')) {
          const newImage = newCard.querySelector('.product-item__image');
          const currentImage = this.querySelector('.product-item__image');
          if (newImage && currentImage) currentImage.replaceWith(newImage);
          return;
        }
        const existingIcons = this.querySelector('.product-item__icons');
        if (existingIcons) {
          const newText = newCard.querySelector('.product-item__text');
          if (newText && !newText.querySelector('.product-item__icons')) {
            const swatches = newText.querySelector('.product-item__plp-swatches');
            const iconsClone = existingIcons.cloneNode(true);
            if (swatches) {
              newText.insertBefore(iconsClone, swatches);
            } else {
              newText.appendChild(iconsClone);
            }
          }
        }
        const existingSwatches = this.querySelector('.product-item__plp-swatches');
        if (existingSwatches && existingSwatches.classList.contains('product-item__plp-swatches--expanded')) {
          const newSwatches = newCard.querySelector('.product-item__plp-swatches');
          if (newSwatches) {
            newSwatches.classList.add('product-item__plp-swatches--expanded');
            const moreButton = newSwatches.querySelector('.product-item__plp-swatches-more');
            if (moreButton) moreButton.remove();
          }
        }
        const existingBadge = this.querySelector('.wc_product_review_badge');
        const isProcessed = existingBadge && existingBadge.querySelector('.rivyoReviewWidget');
        if (isProcessed) {
          const placeholder = newCard.querySelector('.wc_product_review_badge');
          if (placeholder) placeholder.replaceWith(existingBadge.cloneNode(true));
        }
        this.innerHTML = newCard.innerHTML;
        if (!isProcessed) this._initRivyoBadges();
      });
    }

    _initRivyoBadges() {
      const badges = this.querySelectorAll('.wc_product_review_badge');
      if (!badges.length) return;
      const trigger = () => {
        if (typeof window.rivyoPacificRatingWidget !== 'function') return false;
        badges.forEach(el => {
          const pid = el.getAttribute('data-product_id');
          if (pid) window.rivyoPacificRatingWidget(pid);
        });
        return true;
      };
      if (trigger()) return;
      let attempts = 0;
      const id = setInterval(() => {
        attempts += 1;
        if (trigger() || attempts >= 20) clearInterval(id);
      }, 250);
    }

    _loadData() {
      if (this.data) return Promise.resolve(this.data);
      if (this.loadingData) return this.loadingData;
      const productUrl = this.dataset.productUrl;
      if (!productUrl) return Promise.resolve([]);
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('section_id', 'product-card-content');
      this.loadingData = fetch(url.toString())
        .then((res) => res.text())
        .then((markup) => {
          const html = new DOMParser().parseFromString(markup, 'text/html');
          const script = html.querySelector('script[type="application/json"]');
          if (!script) {
            this.data = [];
            return this.data;
          }
          try {
            this.data = JSON.parse(script.textContent.trim());
          } catch (err) {
            this.data = [];
          }
          return this.data;
        })
        .catch(() => {
          this.data = [];
          return this.data;
        });
      return this.loadingData;
    }

  }

  if (typeof customElements.get('product-card') === 'undefined') {
    customElements.define('product-card', ProductCard);
  }

}
